import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=5bb352bc"
import script from "./LangSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./LangSwitcher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=5bb352bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports